import React, { useRef, useEffect, useState } from "react";
import { Card } from "reactstrap";
import { useHistory } from "react-router-dom";
import APopover from "views/pages/manage/common/a-popover";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPostPromisedData, updateRequest } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { getFilterCount } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant"
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { checkPermission } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { getDropdowns } from "./constants";
import ListComponent from "./ListComponent";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const PaymodeAccountConfig = ({ userPermissions }) => {
    const isCreatePermission = checkPermission(userPermissions, "C");
    const isUpdatePermission = checkPermission(userPermissions, "U");
 
    const history = useHistory();
    const ref = useRef();

    const [isLoading, setIsLoading] = useState(false);
    const [dropdowns, setDropdowns] = useState([]);
    const [configs, setConfigs] = useState([]);
    const [paginationInfo, setPaginationInfo] = useState({
        currentPage: 0,
        totalPage: 0,
        totalRecords: 0,
    });
    const [currPageSize, setCurrentPageSize] = useState(50);
    const listRef = useRef();


    const init = async () => {
        try {
            setIsLoading(true);
            const resp = await getDropdowns();
            setDropdowns(resp);
            fetchPaymodes({}, 0, 50, dropdowns);
        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);
        }
    }

    const fetchPaymodes = async (reqObj = {}, pageNumber = 0, pageSize = currPageSize, dropdowns) => {
        try {
            setIsLoading(true);
            const resp = await fetchAllPromisedData(`${endpoint?.sapAccountMaster?.getAll}?offset=${pageNumber}&pageSize=${pageSize}`, true);
            if (resp?.code === 200) {
                setConfigs(resp?.data?.paginatedData);
                setCurrentPageSize(pageSize);
                setPaginationInfo({
                    currentPage: resp?.data?.currentPage,
                    totalPage: resp?.data?.totalPage,
                    totalRecords: resp?.data?.totalRecords,
                });
                listRef.current.stopEditing();
            }

        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);
        }
    }

    const nextButtonHandler = (newPage, currPageSize) => {
        fetchPaymodes({}, newPage, currPageSize);
    }

    const toggleStatusHandler = async rowData => {
        setIsLoading(true);
        setIsLoading(false);
    }

    useEffect(() => {
        init();
    }, [])

    return (
        <>
            <Card className="mx-2">
                <div className="d-flex justify-content-between my-3 mx-2">
                    <div className="d-flex justify-content-between">
                        <BackArrow
                            className="color-black mr-2 cursor"
                            onClick={() => history.goBack()}
                        />
                        <h4 className="color-black">Paymode Account Setup</h4>
                    </div>
                </div>

                <ListComponent
                    rows={configs}
                    rowCount={paginationInfo.totalRecords}
                    ref={ref}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    nextButtonHandler={nextButtonHandler}
                    dropdowns={dropdowns}
                    isUpdatePermission={isUpdatePermission}
                    currentPage={paginationInfo?.currentPage}
                    currPageSize={currPageSize}
                    toggleStatusHandler={toggleStatusHandler}
                />
            </Card>
        </>
    )
}

export default PaymodeAccountConfig